// core/services/admins/customer/queries.ts

import { useQuery } from "@tanstack/react-query"
import { GetCustomerInfo, GetCustomerList, GetCustomerPlans } from "./api.js"
import { CustomerList } from "./key.js"

interface IUseGetCustomerList {
    search?: string
    type?: string
    page?: number
    size?: number
    sortField?: string
    sortDirection?: "ACS" | "DESC" | string
}

// core/services/admins/customer/queris.ts
// core/services/admins/customer/queris.ts

import { GetCustomerPerformanceApi, type CustomerPerformanceParams } from "./api.js";

// ✅ اضافه کن به انتهای فایل
export const useGetCustomerPerformance = (
    params: CustomerPerformanceParams
) => {
    return useQuery({
        queryFn: () => GetCustomerPerformanceApi(params),
        queryKey: ["GetCustomerPerformance", params],
        enabled: !!params.customerId,
        refetchOnWindowFocus: false,
        staleTime: 0,
        gcTime: 0,
    });
};
import { keepPreviousData } from "@tanstack/react-query";

export const useGetCustomerList = ({
    search = "",
    type = "ALL",
    page = 0,
    size = 25,
    sortField = "id",
    sortDirection = "ASC",
}: IUseGetCustomerList = {}) => {
    return useQuery({
        queryFn: () =>
            GetCustomerList({
                search,
                type,
                page,
                size,
                sortField,
                sortDirection,
            }),
        queryKey: [
            "customerList",
            { search, type, page, size, sortField, sortDirection },
        ],
        // ✅ برای pagination نرم بدون فلش زدن
        placeholderData: keepPreviousData,
    });
};

import { CustomerInfo } from "./key.js";

// ============================================
// ✅ دریافت اطلاعات کامل یک مشتری
// ============================================
export const useGetCustomerInfo = (customerId?: number | string) => {
    return useQuery({
        queryFn: () => GetCustomerInfo(Number(customerId)),
        queryKey: CustomerInfo(customerId as any),
    });
};

import {
  GetExcelFileList,
  type GetExcelFileListParams,
} from "./api.js";
import { ExcelFileList } from "./key.js";

export const useGetExcelFileList = ({
  page = 0,
  size = 10,
  sortField = "DECS",
  sortDirection = "DECS",
}: GetExcelFileListParams = {}) => {
  return useQuery({
    queryFn: () =>
      GetExcelFileList({ page, size, sortField, sortDirection }),
    queryKey: ExcelFileList({ page, size, sortField, sortDirection }),
    placeholderData: keepPreviousData,
  });
};
import { CustomerPlans } from "./key.js";

// ============================================
// ✅ دریافت طرح‌های مشتری
// ============================================
export const useGetCustomerPlans = (customerId: any) => {
    return useQuery({
        queryFn: () => GetCustomerPlans(Number(customerId)),
        queryKey: CustomerPlans(customerId),
        enabled: !!customerId,
    });
};